import { ClickEvent, Label, Panel, TableRowCreationEvent, TableRowDisplayEvent, TableRowExpansionEvent } from "@mcleod/components";
import { AutogenLayoutMobileCommListTable } from "./autogen/AutogenLayoutMobileCommListTable";
import { ModelRow, StringUtil } from "@mcleod/core";
import { CommonTooltips } from "@mcleod/common";
import { OrderTabView } from "../OrderTabView";
import { MobileCommMessageText } from "./MobileCommMessageText";
import { MobileCommListToolPanel, ActionButtonType } from "./MobileCommListToolPanel";


const ROW_TYPE_MESSAGE: string = "M"

export class MobileCommListTable extends AutogenLayoutMobileCommListTable {
    private _toolsPanel: MobileCommListToolPanel;

    onLoad(): void | Promise<void> {
        this._toolsPanel = new MobileCommListToolPanel(this, ActionButtonType.ADD, ActionButtonType.REPLY, ActionButtonType.CONFIRM, ActionButtonType.FLEET);
    }

    tableMcMessageOnRowCreate(event: TableRowCreationEvent) {
        const modelRow = event.getTableRow().data as ModelRow;
        const isMessageRowType = modelRow.get("row_type") === ROW_TYPE_MESSAGE;
        event.getTableRow().expandable = isMessageRowType;
    }

    tableMcMessageOnRowExpand(event: TableRowExpansionEvent) {
        const expand = event.expandComponentParent as Panel;
        const layout = expand.findComponentById("layoutMobileCommMessageText") as MobileCommMessageText;
        const mcMessageId: string = (event.target.data as ModelRow).get("id","");
        layout.addLayoutLoadListener(event => layout.sourceMobileCommMessage.search({id: mcMessageId}))
    }

    tableMcMessageOnRowDisplay(event: TableRowDisplayEvent) {
        const modelRow = event.getTableRow().data as ModelRow;
        const labelMessageType = event.getTableRow().findComponentById("labelMessageType") as Label;
        const labelMcUserId = event.getTableRow().findComponentById("labelMcUserId") as Label;
        const labelDriverFullName = event.getTableRow().findComponentById("labelDriverFullName") as Label;
        const labelMCUnitNo = event.getTableRow().findComponentById("labelMCUnitNo") as Label;
        const labelOrderId = event.getTableRow().findComponentById("labelOrderId") as Label;

        labelOrderId.addUnderlineWhenMouseOver();
        const msgSendingStatus = modelRow.get("msg_sending_status");
        const isMessageRowType = modelRow.get("row_type") === ROW_TYPE_MESSAGE;

        switch (modelRow.get("message_type")) {
            case "I": {
                labelMessageType.text = "Inbound";
                if (isMessageRowType) {
                    this.setImageAttributes(event, "I", msgSendingStatus);
                }
                break;
            }
            case "O": {
                labelMessageType.text = "Outbound";
                if (isMessageRowType) {
                    this.setImageAttributes(event, "O", msgSendingStatus);
                }
                break;
            }
        }

        if (!StringUtil.isEmptyString(modelRow.get("mc_user_id"))) {
            CommonTooltips.setTooltipContentLayout(labelMcUserId, modelRow.get("mc_user_id"), "common/UserQuickInfo", { minWidth: 128, minHeight: 140 });
        }

        if (!StringUtil.isEmptyString(modelRow.get("driver_id"))) {
            CommonTooltips.setTooltipContentLayout(labelDriverFullName, modelRow.get("driver_id"), "lme/dispatch/asset/DriverQuickInfo", { minWidth: 128, minHeight: 140 });
        }

        if (!StringUtil.isEmptyString(modelRow.get("mc_unit_no"))) {
            CommonTooltips.setTooltipContentLayout(labelMCUnitNo, modelRow.get("mc_unit_no"), "lme/dispatch/mobilecomm/McUnitQuickInfo", { minWidth: 128, minHeight: 140 });
        }
    }

    private setImageAttributes(event: TableRowDisplayEvent, messageType: string, status: string) {
        const labelStatus = event.getTableRow().findComponentById("labelStatus") as Label;
        const image = this.getImageToDisplay(event, messageType, status);

        if (image == null)
            return;

        image.visible = true;
        if (status == "-1") {
            image.imageColor = "blue";
            labelStatus.text = image.tooltip = "Scheduled";
        }
        else if (status == "0") {
            image.imageColor = "yellow";
            labelStatus.text = image.tooltip = null;
        }
        else if (status == "1") {
            image.color = "yellow";
            labelStatus.text = image.tooltip = "Network";
        }
        else if (status == "2" || status == "3") {
            image.imageColor = "blue";
            labelStatus.text = image.tooltip = "Sent";
        }
        else if (status == "100" || status == "150") {
            image.imageColor = "darkgreen";
            labelStatus.text = image.tooltip = "Arrived";
        } else if (status == "99") {
            image.imageColor= "red";
            labelStatus.text = image.tooltip = "Failed";
        } else if (status == "200") {
            image.imageColor = "primary";
            labelStatus.text = image.tooltip = "Read";
        } else {
            image.imageColor= "red";
            labelStatus.text = image.tooltip = "Failed";
        }
    }

    private getImageToDisplay(event: TableRowDisplayEvent, messageType: string, status: string) : Label {
        if (messageType == "I" && status == "99") {
            return event.getTableRow().findComponentById("messageIncomingOutlined") as Label;
        } else if (messageType == "I" && status != "99") {
            return event.getTableRow().findComponentById("messageIncomingFilled") as Label;
        }
        else if (messageType == "O" && status == "99") {
            return event.getTableRow().findComponentById("messageOutgoingOutlined") as Label;
        }
        else if (messageType == "O" && status != "99") {
            return event.getTableRow().findComponentById("messageOutgoingFilled") as Label;
        }

        return null;
    }

    orderNumberOnClick(event: ClickEvent) {
        OrderTabView.navigateTo({ key: (event.target as Label).text, newTab: true });
    }
}
